export const getPageName = (pathname) => {
  if (!pathname) return;
  const pageName = pathname.includes("technicalData")
    ? "technicalData"
    : pathname.includes("energyPerformance")
    ? "energyPerformance"
    : pathname.includes("certificates")
    ? "certificates"
    : pathname.includes("modernization")
    ? "modernization"
    : pathname.includes("execution")
    ? "execution"
    : "buildingProfile";
  return pageName;
};

export const navigateWithPageReload = ({ replace = false, url }) => {
  if (replace) {
    window.location.replace(url);
  } else {
    window.location.assign(url);
  }
};
